import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { ListItem, Collapse, Tooltip } from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { connect } from "react-redux";
import avatar_default from "assets/img/default-avatar.png";
import { useTranslation } from "react-i18next";
import userManager from "../../utils/userManager";
import {
  LanguageSelectorContainer,
  LanguageSelectorListItem,
  LanguageSelectorSelect,
  LanguageSelectorText,
  MenuCollapseNavLink,
  MenuListItemIcon,
  MenuListItemText,
  MenuNavLink,
  UserAvatarContainer,
  UserCaret,
  UserMenuContainer,
  UserMenuList,
  UserMenuListItem
} from "./MenuStyles";

const UserMenu = ({ miniActive, userProfile, language, changeLanguage }) => {
  const { t } = useTranslation();

  const [openAvatar, setOpenAvatar] = useState(false);

  const logoutClick = useCallback(() => {
    userManager.signoutRedirect();
  }, []);

  const openCollapseAvatar = useCallback(e => {
    e.preventDefault();
    setOpenAvatar(prev => !prev);
  }, []);
  const fullName= userProfile ? userProfile.firstName + " " + userProfile.lastName : ""
  return (
    <UserMenuContainer>
      <UserAvatarContainer>
        <img src={userProfile?.userAdditionalData?.avatar || avatar_default} style={{ width: "100%" }} alt="..." />
      </UserAvatarContainer>
      <UserMenuList>
        <UserMenuListItem>
          <MenuCollapseNavLink to={"/"} onClick={openCollapseAvatar}>
           <Tooltip title ={fullName}>
           <UserCaret active={openAvatar} /> 
            <MenuListItemText
              id="sidebar_userMenu_userName"
              primary={fullName}
              visible={!miniActive}
              disableTypography={true}
            /> 
            </Tooltip>
          </MenuCollapseNavLink>
          <Collapse in={openAvatar} unmountOnExit>
            <UserMenuList>
              {userProfile ? (
                <UserMenuListItem>
                  <MenuNavLink to={"/"} onClick={logoutClick}>
                    <MenuListItemIcon>
                      <PowerSettingsNewIcon />
                    </MenuListItemIcon>
                    <MenuListItemText visible={!miniActive} primary={t("Tooltips.Logout")} disableTypography={true} />
                  </MenuNavLink>
                </UserMenuListItem>
              ) : (
                ""
              )}
              <ListItem>
                <LanguageSelectorContainer>
                  <LanguageSelectorSelect
                    id="sidebar_userMenu_langSelector"
                    miniActive={miniActive}
                    value={language}
                    onChange={changeLanguage}
                    variant="standard"
                  >
                    <LanguageSelectorListItem color="black" button value="ro-RO" id="sidebar_userMenu_langSelector_ro">
                      <img src="/static/flags/flags-iso/shiny/32/RO.png" alt="ro-RO" />
                      {!miniActive && <LanguageSelectorText>{"Romana"}</LanguageSelectorText>}
                    </LanguageSelectorListItem>
                    <LanguageSelectorListItem button value="en-GB" id="sidebar_userMenu_langSelector_en">
                      <img src="/static/flags/flags-iso/shiny/32/GB.png" alt="en-GB" />
                      {!miniActive && <LanguageSelectorText>{"English"}</LanguageSelectorText>}
                    </LanguageSelectorListItem>
                    <LanguageSelectorListItem button value="fr-FR" id="sidebar_userMenu_langSelector_fr">
                      <img src="/static/flags/flags-iso/shiny/32/FR.png" alt="fr-FR" />
                      {!miniActive && <LanguageSelectorText>{"Français"}</LanguageSelectorText>}
                    </LanguageSelectorListItem>
                  </LanguageSelectorSelect>
                </LanguageSelectorContainer>
              </ListItem>
            </UserMenuList>
          </Collapse>
        </UserMenuListItem>
      </UserMenuList>
    </UserMenuContainer>
  );
};

UserMenu.propTypes = {
  miniActive: PropTypes.bool.isRequired,
  userProfile: PropTypes.object,
  changeLanguage: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  let userProfile;
  if (state && state.userInfo) userProfile = state.userInfo;

  return {
    userProfile: userProfile
  };
}

export default connect(mapStateToProps)(UserMenu);
